import React from 'react';
import PropTypes from 'prop-types';
import { loadReCaptcha } from 'react-recaptcha-v3';

import LoginForm from '../../components/newForms/LoginForm';

import './EventbriteLoginOptions.scss';

export default class EventbriteLoginOptions extends React.Component {
    static propTypes = {
        onLogInUser: PropTypes.func,
        clearAuthNotification: PropTypes.func,
        onLookupUser: PropTypes.func,
        handleClickViewPassword: PropTypes.func,
        resetForm: PropTypes.func,
    };

    componentDidMount() {
        if (!this.props.disableRecaptcha3) {
            loadReCaptcha(this.props.recaptcha3PublicKey);
        }
    }

    _handleSubmit = (formData) => {
        const {
            clearAuthNotification,
            onLogInUser,
            isLookupLoading,
        } = this.props;
        // clear notification  everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }

        return !isLookupLoading && onLogInUser(formData);
    };

    //When user clicks on view password
    _handleOnIconClick = () => {
        const { handleClickViewPassword } = this.props;
        if (handleClickViewPassword) {
            handleClickViewPassword();
        }
    };

    _handleFormReset = () => {
        const { resetForm } = this.props;
        //reset form fields
        if (resetForm) {
            resetForm('logInForm');
        }
    };

    render() {
        const {
            buttonCTA,
            handleShowNotification,
            handleClearNotification,
            onLookupUser,
            clearAuthNotification,
            handleForgotPassword,
            handleClickViewPassword,
            recaptcha2PublicKey,
            recaptcha3PublicKey,
            disableRecaptcha3,
            showCaptcha,
            isSoftAccount,
            handleSoftAccount,
            resetForm,
            email,
            showForgotPassword,
            launchPasswordlessLogin,
        } = this.props;
        return (
            <div
                className="eventbrite-login-section"
                data-automation="eventbrite-login-section"
            >
                <LoginForm
                    buttonCTA={buttonCTA}
                    onSubmit={this._handleSubmit}
                    onLookupUser={onLookupUser}
                    clearAuthNotification={clearAuthNotification}
                    handleForgotPassword={handleForgotPassword}
                    recaptcha2PublicKey={recaptcha2PublicKey}
                    recaptcha3PublicKey={recaptcha3PublicKey}
                    disableRecaptcha3={disableRecaptcha3}
                    showCaptcha={showCaptcha}
                    showNotification={handleShowNotification}
                    clearNotification={handleClearNotification}
                    handleClickViewPassword={handleClickViewPassword}
                    handleFormReset={this._handleFormReset}
                    isSoftAccount={isSoftAccount}
                    handleSoftAccount={handleSoftAccount}
                    resetForm={resetForm}
                    initialValues={{ email: email }}
                    showForgotPassword={showForgotPassword}
                    launchPasswordlessLogin={launchPasswordlessLogin}
                />
            </div>
        );
    }
}
